export default "__VITE_ASSET__da9d6383__"